import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { BreadCrambs } from './BreadCrambs';
import { getStringWithUpperFirstChar } from '../../../functions/getStringWithUpperFirstChar';
import { getFormatedData } from '../../../functions/getFormatedData';
import { getRootCategories } from '../../../functions/getRootCategories';
import { LinkButton } from '../../UI/LinkButton';
import { colors } from '../../../styles/colors';

const Container = styled.section`
    @media (min-width: 960px) {
        .list {

            > div:nth-child(even) {
                padding-left: 5rem;
    
                .block_picture {
                    order: 1;
                }
            }
            > div:nth-child(odd) {    
                .block_picture {
                    margin-right: 5rem;
                }
            }
        } 
    }
    .width-limiter {
        max-width: 1920px;
    }   
`;
const RootCategoryBlockContainer = styled.div`
    padding: 10rem 0;
    :not(:last-child) {
        border-bottom: 1px solid black;
    }
    @media (max-width: 959.98px) {
        padding: 10rem 5rem;
    }

    // INCLUDED CLASSES:

    .width-limiter {
        max-width: 1920px;
        display:flex;
        padding: 0;
    }

    .block_picture {
        @media (min-width: 960px) {
            width: 100%;
            height: 600px;

            background: url(${props => props.background_picture}) no-repeat 100% 50%;
            background-size: cover;
        }
    }
    .text-content-wrapper {
        @media (min-width: 960px) {
            width: 100%;
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
    .title {
        max-width: 550px;
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 6rem;
        line-height: 167%;
        color: ${colors.dark_blue};
        margin-bottom: 3.75rem;

        @media (min-width: 960px) {
            margin-bottom: 12.5rem;
        }
        @media (max-width: 476px) {
            font-size: 3.5rem;
            margin: 3rem 0;
        }
    }
`

const RootCategoryBlock = ({category, className, picture}) =>{

    const title = getStringWithUpperFirstChar(category.category_name)

    return (
        <RootCategoryBlockContainer background_picture={picture} className={className} >
            <div className="width-limiter">
                <div className="block_picture" />
                <div className="text-content-wrapper">
                    <p className="title"> { title } </p>
                    <LinkButton link={`/products/${category.category_name}`} text='Перейти в каталог' />
                </div>
            </div>
        </RootCategoryBlockContainer>
    )
}

export const ProductsLandingPage = () => {

    const root_categories = getRootCategories(getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories)))

    return (
        <Container>
            <div className="width-limiter">
                <BreadCrambs />
            </div>
            <div className="list">
                { root_categories.map( (category, i) => <RootCategoryBlock picture={category.category_picture.url}  category={category} className={i+1} key={i} />   ) }
            </div>
        </Container>
    )
}
